import { IBookmakerDictionaryApi } from '@/types';
import { useRemoteDictionaryHelpers } from '@/stores/utils/useRemoteDictionaryHelpers';
import { BotDictionaryItem } from '@/models/dictionary/bot';

export const useBotDictionary = defineStore('botDictionary', () => {
    const items = shallowRef<BotDictionaryItem[]>([]);

    const { itemById, nameById } = useRemoteDictionaryHelpers(items);

    // actions
    function setData(data: IBookmakerDictionaryApi[]) {
        console.time('set-bot-dictionary');
        items.value = data.map((item) => new BotDictionaryItem(item));
        console.timeEnd('set-bot-dictionary');
    }

    return {
        items,
        itemById,
        nameById,
        setData,
    };
});
